import React from 'react'
import '../styles/Contact.css'
import Sartoretti from '../assets/profile-pictures/Sartoretti.png';
import Insaf from '../assets/profile-pictures/Insaf.png';
import { AiOutlineLink, AiFillGithub, AiOutlineMail, AiFillLinkedin} from 'react-icons/ai';
import {SiGooglescholar} from 'react-icons/si';

const Contact = () => {
    return (
        <div className='contact-page'>
            <h1>Contact Our Team</h1>
            <p>At our core, we believe that open communication is the foundation of any 
                successful relationship. We invite you to reach out to us with your inquiries, 
                ideas for collaboration, or simply to share your thoughts. We genuinely look 
                forward to hearing from you.</p>
            <div className='team_container'>
                <div className='profile__item'>
                    <div className='profile__item-image'>
                        <img src={Sartoretti} alt={"Guillaume Sartoretti"} />
                    </div>
                    <h3>Guillaume Sartoretti</h3>
                    <h4>Project Supervisor</h4>
                    <small>As the Project Supervisor for PRIMAL GRID, Professor Sartoretti is responsible
                        for managing and overseeing all aspects of the project to ensure standards are met.
                    </small>
                    <div className='profile__footer__socials'>
                        <a href="https://www.marmotlab.org/bio.html"><AiOutlineLink /></a>
                        <a href="https://scholar.google.com/citations?user=n7NzZ0sAAAAJ&hl=fr&oi=ao"><SiGooglescholar/></a>
                        <a href="https://github.com/gsartoretti"><AiFillGithub /></a>
                        <a href="mailto:guillaume.sartoretti@nus.edu.sg"><AiOutlineMail /></a>

                    </div>
                </div>
                <div className='profile__item'>
                    <div className='profile__item-image'>
                        <img src={Insaf} alt={"Insaf Zainudin"} />
                    </div>
                    <h3>Insaf Zainudin</h3>
                    <h4>Project Lead Developer</h4>
                    <small>As the Lead Developer for PRIMAL GRID, Insaf is responsible for overseeing
                        the technical aspects of the project to deliver an innovative and successful application.
                    </small>
                    <div className='profile__footer__socials'>
                        <a href="https://insaf.netlify.com"><AiOutlineLink /></a>
                        <a href="https://www.linkedin.com/in/insafzainudin/"><AiFillLinkedin/></a>
                        <a href="https://github.com/insafhere"><AiFillGithub /></a>
                        <a href="mailto:insaf@u.nus.edu"><AiOutlineMail /></a>
                    </div>

                </div>
            </div>



        </div>
    )
}

export default Contact
